import React, { useEffect, useState } from 'react'

function EmptyConversation({ assignScreen }) {
  const [Class, setClass] = useState('')
  useEffect(() => {
    setClass('Animate')
    console.log('empty conversation mounted')
  }, [])

  return (
    <div className={`conversastion-list__main conversation-list__${assignScreen ? '' : 'un-'}assign-screen ${Class}`}>
      <img className='conversastio-list__img' src='/images/EmptyState.png' />
      <div>
      <h5>Your list is empty</h5>
      </div>
    </div>
  )
}

export default EmptyConversation


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/ConversationList/EmptyConversation.js